// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4b0e13b0","667":"6d7c46ae"}[chunkId] + ".chunk.js";
};